export default __webpack_public_path__ + "static/planeInCloudsBig-bf583c660fcd3cb7aeac155c9f8cc179.png";